import React, { useState } from 'react';
import { SessionContext } from '~/modules/contexts';

const SessionProvider = ({ children }) => {
	const [auth, setAuth] = useState({
		session: null,
		isLoggedIn: false,
		isResetingPassword: false,
		lastAttemptedAt: null,
		loginError: false,
		resetPasswordError: false,
		resetPasswordSuccess: false,
		twoFactorLogin: false
	});

	return (
		<SessionContext.Provider value={
			{
				auth, setAuth
			}
		}
		>
			{children}
		</SessionContext.Provider>
	);
};

export default SessionProvider;